import axios from "axios";
import helper from "../../util/helper";
import objectUtils from "../../util/objectUtils";
import Vue from "vue";
import AWS from "aws-sdk";

const getDefaultSelectedItemGroup = () => {
  return {
    itemGroupType: { id: null },
    name: null,
    rowSize: null,
    colSize: null,
    seatMaps: [],
    itemGroupObjects: [],
    itemGroupProperties: [],
    itemGroupRules: [],
  };
};

export default {
  state: () => ({
    selectedItemGroup: getDefaultSelectedItemGroup(),
    itemGroups: [],
  }),

  mutations: {
    setSelectedItemGroup(state, itemGroup) {
      Vue.set(state, "selectedItemGroup", itemGroup);
    },
    setItemGroups(state, itemGroups) {
      Vue.set(state, "itemGroups", itemGroups);
    },
    setDefaultSelectedItemGroup(state) {
      Vue.set(state, "selectedItemGroup", getDefaultSelectedItemGroup());
    },
    setDefaultItemGroupModule(state) {
      Vue.set(state, "selectedItemGroup", getDefaultSelectedItemGroup());
      Vue.set(state, "itemGroups", []);
    },
  },

  actions: {
    createItemGroups: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/item-groups/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          context.dispatch("loadItemGroups");
          return response.data;
        })
        .catch((err) => {
          return err.response;
        });
    },

    loadItemGroups: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/entity").then((response) => {
        context.commit("setItemGroups", response.data);
        return response.data;
      });
    },
    loadItemGroup: (context, itemGroupId) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/entity/" + itemGroupId).then((response) => {
        // return objectUtils.convertPublishModelToUpdateModel(response.data);
        return response.data;
      });
    },

    loadPublishedItemGroups: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/entity/published").then((response) => {
        let orderedItemGroups = response.data.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
        context.commit("setItemGroups", orderedItemGroups);
        return response.data;
      });
    },

    loadPublishedItemGroupsWithObjects: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/entity/with-objects").then((response) => {
        let orderedItemGroups = response.data.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
        context.commit("setItemGroups", orderedItemGroups);
        return response.data;
      });
    },

    loadItemGroupsHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/item-groups/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },

    loadSelectedItemGroupsHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },

    deleteItemGroups: (context, itemGroup) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/item-groups/entity/" + itemGroup.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          itemGroup.intents = intents;
          itemGroup.intentId = response.data.id;
          return itemGroup;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftItemGroups: (context, itemGroup) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/item-groups/delete/" + itemGroup.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },

    publishItemGroups: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/publish/" + request.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },

    rejectItemGroups: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/reject/" + request.intentId).then((response) => {
        helper.recallOrRejectEntity(request, "ITEM_GROUP");

        return response.data;
      });
    },

    recallItemGroup: (context, itemGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/recall/" + itemGroup.intentId).then((response) => {
        //TODO: Bu item ismini bilmiyoruz. Kontrol edilecek.
        helper.recallOrRejectEntity(itemGroup, "ITEM_GROUP");
        return response.data;
      });
    },

    cancelItemGroup: (context, itemGroup) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/cancel/" + itemGroup.intentId).then((response) => {
        //TODO: Bu item ismini bilmiyoruz. Kontrol edilecek.
        return response.data;
      });
    },

    sendToApprovalItemGroups: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-groups/sendToApproval/" + request.intentId).then((response) => {
        helper.recallOrRejectEntity(request, "ITEM_GROUP");
        return response.data;
      });
    },
    loadPublishedItemGroupProperties: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-properties/entity/published").then((response) => {
        return response.data;
      });
    },
    loadPublishedItemGroupRules: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/item-group-rules/entity/published").then((response) => {
        return response.data;
      });
    },
  },

  getters: {
    getSelectedItemGroup: (state) => {
      return state.selectedItemGroup;
    },
    getItemGroups: (state) => {
      return state.itemGroups;
    },
  },
};
